import React, { useEffect, useState } from 'react'
import { Button } from '../UI/index'
import Modal from '@material-ui/core/Modal'
import closeIcon from '../../assetss/img/closeModalIcon.svg'
import './index.scss'

const SignUpPopup = ({ isAuth, onSignUp }) => {
  const [open, setOpen] = useState(false)
  const isOpen = sessionStorage.getItem('openModal')
  const a = ''

  const onClose = () => setOpen(false)

  useEffect(() => {
    if (!isOpen && !isAuth) {
      setTimeout(() => {
        setOpen(true)

        sessionStorage.setItem('openModal', 1)
      }, 30000)
    }
  }, [isOpen])

  return (
    <div>
      <Modal
        open={open}
        onClose={onClose}
      >
        <div className='wrapperStoryBannerModal' onClick={onClose}>
          <div className='wrapper'>
            <img
              onClick={onClose}
              className='closeIcon'
              src={closeIcon}
              alt='closeIcon'
            />
            <h3 className='title'>
              Sign up to:
            </h3>

            <ul className='listModal'>
              <li>
                tell your story and receive support
              </li>

              <li>
                communicate with author of this article
              </li>
            </ul>

            <Button
              onClick={onSignUp}
              className='modalButtonLogin'
              variant='contain'
            >
              Sign up
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default SignUpPopup
